import locale from "@bonliva-crm/locale";
import { ContentCopyIcon } from "@bonliva-crm/ui";
import { Box, Tooltip, Typography, makeStyles } from "@material-ui/core";
import { useState } from "react";

const copyToClipboard = (text?: string | null) => {
  if (text) navigator.clipboard.writeText(text);
  return;
};

export const Item = ({
  value,
  valueType = "text",
  iconLeft,
  iconRight,
  title,
  canCopy: _canCopy = false
}: {
  value?: React.ReactNode;
  valueType?: "email" | "phone" | "text" | "h5";
  iconLeft?: React.ReactElement;
  iconRight?: React.ReactElement;
  title?: string;
  canCopy?: boolean;
}) => {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);
  if (!value) return;

  const canCopy = _canCopy && typeof value === "string";

  const copyIcon = canCopy ? (
    <ContentCopyIcon
      className={classes.contentCopy}
      style={{ display: "inline" }}
      onClick={() => {
        copyToClipboard(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 500);
      }}
    />
  ) : undefined;

  const valueElement = (() => {
    switch (valueType) {
      case "text":
      case "h5": {
        return (
          <div
            style={{
              display: "inline"
            }}
          >
            {iconLeft}
            <Typography
              variant={valueType === "h5" ? "h5" : "body1"}
              style={{
                display: "inline"
              }}
            >
              {value}
            </Typography>
            <div style={{ display: "inline-block" }}>
              {iconRight}
              {copyIcon}
            </div>
          </div>
        );
      }
      case "email": {
        return (
          <div style={{ display: "inline", maxWidth: "100%" }}>
            {iconLeft}
            <a className={classes.link} href={`mailto:${value}`}>
              {value}
            </a>
            <div style={{ display: "inline-block" }}>
              {iconRight}
              {copyIcon}
            </div>
          </div>
        );
      }
      case "phone": {
        return (
          <div style={{ display: "inline", maxWidth: "100%" }}>
            {iconLeft}
            <a className={classes.link} href={`tel:${value}`}>
              {value}
            </a>
            <div style={{ display: "inline-block" }}>
              {iconRight}
              {copyIcon}
            </div>
          </div>
        );
      }
    }
  })();

  return (
    <Box className={classes.root}>
      {title && (
        <Typography variant="h6" component="span" style={{ display: "inline" }}>
          {title}:{" "}
        </Typography>
      )}
      {canCopy ? (
        <Tooltip
          title={copied ? locale.Copied : locale.CopyToClipboard}
          placement="bottom"
        >
          <div className={classes.valueWrapper}>{valueElement}</div>
        </Tooltip>
      ) : (
        valueElement
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "inline-block"
  },
  link: {
    color: theme.palette.primary.main,
    fontSize: "1rem",
    wordWrap: "break-word",
    wordBreak: "break-all",
    display: "inline",
    position: "relative"
  },
  contentCopy: {
    visibility: "hidden",
    width: "16px",
    height: "16px",
    cursor: "pointer",
    verticalAlign: "text-top"
  },
  valueWrapper: {
    position: "relative",
    display: "inline",
    flexDirection: "row",
    maxWidth: "100%",
    "&:hover > div > div > svg": {
      visibility: "visible"
    }
  }
}));
